import styled from 'styled-components';
import { windowMaxWidth } from './breakpoints';

const PageWrapper = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  width: calc(100% - 40px);
`;

const MainContainer = styled.div`
  display: flex;
  gap: 20px;
  height: calc(100vh - 181px);
  min-height: 400px;
  overflow: clip;

  @media ${windowMaxWidth.splitScreen} {
    height: calc(100vh - 180px);
  }
`;

const SidebarWrapper = styled.div`
  background-color: var(--greyscale-white);
  border: 1px solid var(--greyscale-dark-white);
  border-radius: var(--border-radius-regular);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  transition: width 0.2s ease;
  width: 242px;

  @media ${windowMaxWidth.splitScreen} {
    width: 56px;
  }
`;

const ContentArea = styled.div`
  border-radius: var(--border-radius-regular);
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
`;

const AdministrationLayout = { PageWrapper, MainContainer, SidebarWrapper, ContentArea };
export default AdministrationLayout;
